import { Global } from "../Shared/Global"

class Player {
    // 基本信息
    private token: string = ""
    private money: number = 0
    private userID: string = ""
    private userFlag: number = 0
    private head: string = ""
    private nickname: string = ""
    private realName: string = ""
    private phone: string = ""
    private WeChat: String = ""
    private QQ: string = ""
    private mail: string = ""
    // vip信息
    private vip: number = 0
    private exp: number = 0
    private expNextVip: number = 0
    private percentage = null;

    // 是否设置过提现密码
    private isSetDrawPassword: boolean = false
    // 游客补全资料的时机。1登录时、2游戏时、3充值时、4提现时。如“2,3”
    private visitorFillInfoTime: string = ""
    // 货币名字
    private currencyName: string = "";
    private languageFlag: string = "";

    // 货币名字
    private currencyRate: string = "";
    // 货币名字
    private languageName: string = "";
    // 货币名字
    private currencySymbol: string = "";
    // 服务器用户数据
    private serverData: {} = {}
    private userType : Number = 0;//0：正常用户 ，1：测试用户，2：初始游客，3资料补全游客

    // 设置属性
    setPy (property, value) {
        if (this.hasOwnProperty(property)) {
			let old = this[property]
            this[property] = value
        	cc.director.emit(Global.UserEvent.PlayerPyChanged, {property: property, old: old, now: this[property]})
        }
        
        if (property === "token") {
            cc.sys.localStorage.setItem('Token', value)
            value && cc.director.emit(Global.UserEvent.PlayerLogin)
        }else if (property === "userID") {
            // 游戏盾要用到
            cc.sys.localStorage.setItem('UserID', value)
        }

        if (property === "serverData" && value) {
            value.totalMoney !== undefined && this.setPy("money", value.totalMoney)
            value.userId !== undefined && this.setPy("userID", value.userId)
            value.userFlag !== undefined && this.setPy("userFlag", value.userFlag)
            value.imageUrl !== undefined && this.setPy("head", value.imageUrl)
            value.nickName !== undefined && this.setPy("nickname", value.nickName)
            value.realName !== undefined && this.setPy("realName", value.realName)
            value.phone !== undefined && this.setPy("phone", value.phone)
            value.wechat !== undefined && this.setPy("WeChat", value.wechat)
            value.qq !== undefined && this.setPy("QQ", value.qq)
            value.email !== undefined && this.setPy("mail", value.email)
            value.vipExp !== undefined && this.setPy("exp", value.vipExp)
            value.isTestOnline !== undefined && this.setPy("userType", value.isTestOnline)//是否测试线： 0：正常用户 ，1：测试用户，2：初始游客
            value.percentage !== undefined && this.setPy("percentage", value.percentage)//进度条相关；

            if(value.currencyLanguageDto){
                this.setPy("languageFlag", value.currencyLanguageDto.languageFlag);
                this.setPy("currencyName", value.currencyLanguageDto.currencyName);
                this.setPy("currencyRate", value.currencyLanguageDto.currencyRate);
                this.setPy("languageName", value.currencyLanguageDto.languageName)
                this.setPy("currencySymbol", value.currencyLanguageDto.currencySymbol)

                let win: any = window
                let languages = win.i18n.languages[value.currencyLanguageDto.languageFlag]
                Global.currencySymbol = languages['currency_symbol']
            }

            // vip配置信息
            let userVipSettingList = value.userVipSettingList || []
            userVipSettingList[0] !== undefined && this.setPy("vip", userVipSettingList[0].userVip)
            userVipSettingList[1] !== undefined && this.setPy("expNextVip", userVipSettingList[1].totalValidBetNumber * 10000)

            // 是否设置过提现密码
            value.setDrawPassword !== undefined && this.setPy("isSetDrawPassword", value.setDrawPassword)
        }
    }

    // 获取属性
    getPy (property) {
		return this[property]
    }

    // 注销
    logout () {
        this.setPy("token", "")
        this.setPy("money", 0)
        this.setPy("userID", "")
        this.setPy("userFlag", 0)
        this.setPy("head", "")
        this.setPy("nickname", "")
        this.setPy("realName", "")
        this.setPy("phone", "")
        this.setPy("WeChat", "")
        this.setPy("QQ", "")
        this.setPy("mail", "")
        // vip信息
        this.setPy("vip", 0)
        this.setPy("exp", 0)
        this.setPy("expNextVip", 0)
        // 是否设置过提现密码
        this.setPy("expNextVip", 0)
        // 服务器用户数据
        this.setPy("setDrawPassword", false);

        this.setPy("currencyName","");
        this.setPy("currencyRate", "");
        this.setPy("languageName", "")
        this.setPy("currencySymbol", "")
        this.setPy("isSetDrawPassword","")

        cc.director.emit(Global.UserEvent.PlayerLogout)
    }

    isLogedIn (): boolean {
        return !!this.getPy("token")
    }

    // 是否为游客登录
    isVisitor (): boolean {
        let userType = this.getPy("userType");
        return (userType === 2);//是否测试线： 0：正常用户 ，1：测试用户，2：初始游客
    }
}

export default new Player()